<template> 
  <tr style="text-align: center;">
    <th> <a v-bind:href="'record.html?id='+record_id" target="_blank"> {{ record_id }} </a> </th>
    <td> {{ full_res_name   }}                                                              </td> 
    <td> <a v-bind:href="'https://www.rcsb.org/structure/'+pdb_id"> {{ pdb_id }} </a>       </td> 
    <td> {{  chain_id       }}                                                              </td> 
    <td> {{  res_num        }}                                                              </td> 
    <td> {{  binder_type    }}                                                              </td> 
    <td> {{  warhead_name   }}                                                              </td> 
    <td> {{  binder_id      }}                                                              </td> 
    <td  class="img-container" v-html="binder_mol">                                         </td> 
    <td  class="img-container" v-html="adduct_pdb">                                         </td> 
    <td> <a v-bind:href="'https://doi.org/'+doi"> {{ doi }} </a>                            </td>  
  </tr> 
</template>

<script>
export default {
  name: 'recordEntry',
  props: ['record_id','pdb_id','chain_id','res_num','full_res_name','binder_type','warhead_name','binder_id','binder_mol','adduct_pdb','doi','strategy'], 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
a {
  color: #42b983;
}
</style>
